import { cn } from "@/lib/utils";

const MONITOR_EVENTS = [
  { label: "Workload detected", detail: "Day 0", tone: "ok" },
  { label: "Review completed", detail: "+7d", tone: "muted" },
  { label: "Retention changed", detail: "+14d", tone: "warning" },
  { label: "Drift detected", detail: "+15d", tone: "alert" },
] as const;

export function MonitorVisual() {
  return (
    <div className="flex min-h-[220px] items-center rounded-lg border border-border bg-surface p-4 shadow-sm sm:min-h-[260px] sm:p-5">
      <div className="w-full">
        <div className="mb-6 flex items-center justify-between gap-3">
          <p className="font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-primary">
            Workload monitoring
          </p>
          <span className="rounded-sm border border-[var(--warning)]/35 bg-[var(--warning-bg)] px-2 py-1 text-[12px] font-semibold text-[var(--warning-text)]">
            Drift detected
          </span>
        </div>
        <div className="relative grid gap-3 sm:grid-cols-4">
          <div aria-hidden="true" className="absolute left-4 right-4 top-[1.1rem] hidden h-px bg-border sm:block" />
          {MONITOR_EVENTS.map((event) => (
            <div key={event.label} className="relative">
              <div
                className={cn(
                  "relative min-h-28 rounded-md border bg-background p-4 shadow-sm",
                  event.tone === "ok" && "border-primary/35 bg-primary-tint/20",
                  event.tone === "muted" && "border-border bg-secondary/35",
                  event.tone === "warning" && "border-[var(--warning)]/45 bg-[var(--warning-bg)]/25",
                  event.tone === "alert" && "border-[var(--error)]/45 bg-[var(--error-bg)]/40",
                )}
              >
                <span
                  className={cn(
                    "block size-2 rounded-full ring-4",
                    event.tone === "ok" && "bg-primary",
                    event.tone === "muted" && "bg-foreground-muted",
                    event.tone === "warning" && "bg-[var(--warning)]",
                    event.tone === "alert" && "bg-[var(--error)]",
                    event.tone === "ok" && "ring-primary-tint",
                    event.tone === "muted" && "ring-secondary",
                    event.tone === "warning" && "ring-[var(--warning-bg)]",
                    event.tone === "alert" && "ring-[var(--error-bg)]",
                  )}
                />
                <p className="mt-4 text-sm font-semibold leading-tight text-foreground">
                  {event.label}
                </p>
                <p className="mt-2 font-mono text-[12px] text-foreground-muted">
                  {event.detail}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
